<ng-container *ngIf="assignment">
  <h5>{{ 'externalEmployees.masterData.employeeDetails.title' | translate }}</h5>
  <div class="py-3">
    <div
      *ngIf="assignment.distance"
      class="row py-2"
    >
      <div class="col-3">
        <span
          baseTruncate
          class="fw-bold"
          >{{ 'externalEmployees.masterData.employeeDetails.distanceToLocation' | translate }}</span
        >
      </div>
      <div class="col-9">
        <span baseTruncate>{{ assignment.distance }}km</span>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-3">
        <span
          baseTruncate
          class="fw-bold"
          >{{ 'provider' | translate }}</span
        >
      </div>
      <div class="col-9">
        <span baseTruncate
          ><span class="fw-bold">{{ assignment.psp?.name }}</span>
          <ng-container *ngIf="assignment.pspBranch?.name"> <br />{{ assignment.pspBranch.name }} </ng-container>
        </span>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-3">
        <span
          baseTruncate
          class="fw-bold"
          >{{ 'externalEmployees.masterData.employeeDetails.staffId' | translate }}</span
        >
      </div>
      <div class="col-9">
        <span baseTruncate>{{ assignment.profile?.personalId | baseIsEmpty }}</span>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-3">
        <span
          baseTruncate
          class="fw-bold"
          >{{ 'externalEmployees.masterData.employeeDetails.internalStaffId' | translate }}</span
        >
      </div>
      <div class="col-9">
        <ng-container *ngIf="!isInternalPersonalIdEdited">
          <span>{{ assignment.profile?.customerProfilePersonalId | baseIsEmpty }}</span>
          <i
            *ngIf="canEditPersonalId"
            class="fa-solid fa-pen ms-2 pointer"
            (click)="isInternalPersonalIdEdited = true"
          ></i>
        </ng-container>
        <div
          *ngIf="isInternalPersonalIdEdited"
          class="d-flex align-items-center"
        >
          <form
            [formGroup]="internalPersonalIdForm"
            [ngClass]="{ 'was-validated': isInternalPersonalIdFormSubmitted }"
          >
            <base-input
              placeholder=""
              [isInvalid]="!!internalPersonalIdForm.get('internalPersonalId').errors"
              [errorMessage]="internalPersonalIdForm.get('internalPersonalId').errors | baseFieldValidation"
              formControlName="internalPersonalId"
            ></base-input>
          </form>
          <div class="d-flex align-items-center gap-2">
            <i
              class="fa-solid fa-check ms-2 pointer"
              (click)="updateInternalPersonalId()"
            ></i>
            <i
              class="fa-solid fa-xmark pointer"
              (click)="cancelUpdate()"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isTerminalFeatureActive"
      class="row py-2"
    >
      <div class="col-3 pt-2">
        <span
          baseTruncate
          class="fw-bold"
          >{{ 'externalEmployees.masterData.employeeIdCard.title' | translate }}</span
        >
      </div>
      <div class="col-9 d-flex gap-3">
        <base-button
          color="dark"
          icon="fa-solid fa-eye"
          stateClass="pe-1"
          [size]="buttonSizes.md"
          [iconSize]="buttonSizes.md"
          [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.showCard' | translate"
          (btnClick)="downloadIDCard(true)"
        ></base-button>
        <base-button
          color="dark"
          icon="fa-solid fa-arrows-rotate"
          stateClass="pe-1"
          [size]="buttonSizes.md"
          [iconSize]="buttonSizes.md"
          [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.regenerateCard' | translate"
          (btnClick)="openRegenerateIDModal()"
        ></base-button>
        <base-button
          color="dark"
          icon="fa-solid fa-download"
          stateClass="pe-1"
          [size]="buttonSizes.md"
          [iconSize]="buttonSizes.md"
          [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.downloadCard' | translate"
          (btnClick)="downloadIDCard(false, true)"
        ></base-button>
      </div>
    </div>
  </div>
  <base-customer-shift-readiness [profile]="assignment.profile"></base-customer-shift-readiness>
  <h5 class="mt-3">{{ 'qualifications.singular' | translate }}</h5>
  <div class="py-3">
    <div class="row py-2 qualification-text-color">
      <div class="col-3">
        <span class="fw-bold">{{ 'externalEmployees.masterData.qualifications.primary' | translate }}</span>
      </div>
      <div class="col-9">
        <span class="qualification-text-color">{{ assignment.profile?.mainQualification.name }}</span>
      </div>
    </div>
    <div class="row py-2 secondary-qualification-text-color">
      <div class="col-3">
        <span class="fw-bold">{{ 'externalEmployees.masterData.qualifications.secondary' | translate }}</span>
      </div>
      <div class="col-9">
        <span>
          <ng-container *ngFor="let qualification of assignment.profile?.qualifications; let isLast = last">
            <span class="secondary-qualification-text-color">{{ qualification.name }}</span> <br *ngIf="!isLast" />
          </ng-container>
        </span>
      </div>
    </div>
  </div>
  <h5 class="mt-3">{{ 'work.conditions.alt' | translate }}</h5>
  <div class="py-3">
    <div
      *ngFor="let requirementCategory of assignment.profile?.requirements"
      class="row py-2"
    >
      <div class="col-3">
        <span class="fw-bold">{{ requirementCategory.name }}</span>
      </div>
      <div class="col-9">
        <span *ngFor="let requirement of requirementCategory.requirements; let isLast = last">
          {{ requirement.name }}
          <br *ngIf="!isLast" />
        </span>
      </div>
    </div>
    <base-empty-list-row
      *ngIf="!assignment.profile?.requirements.length"
      message="inquiry.noRequirementsStored"
      [backgroundSecondary]="true"
      [hideBackgroundImage]="true"
    ></base-empty-list-row>
  </div>
  <h5 class="mt-3">{{ 'externalEmployees.masterData.recentAssignments.title' | translate }}</h5>
  <div class="listview">
    <div class="listview-header row">
      <div
        (click)="onOrderChanged(listHeaderSortKeys.period)"
        [ngClass]="{
          sortable: !orderDirection || orderKey !== listHeaderSortKeys.period,
          'sortable-asc': orderDirection === directions.asc && orderKey === listHeaderSortKeys.period,
          'sortable-desc': orderDirection === directions.desc && orderKey === listHeaderSortKeys.period,
          pointer: endedAssignments?.length
        }"
        class="col-4"
      >
        <span baseTruncate>{{ 'inquiry.period' | translate }}</span>
      </div>
      <div
        (click)="onOrderChanged(listHeaderSortKeys.department)"
        [ngClass]="{
          sortable: !orderDirection || orderKey !== listHeaderSortKeys.department,
          'sortable-asc': orderDirection === directions.asc && orderKey === listHeaderSortKeys.department,
          'sortable-desc': orderDirection === directions.desc && orderKey === listHeaderSortKeys.department,
          pointer: endedAssignments?.length
        }"
        class="col-3"
      >
        <span baseTruncate>{{ 'department.singular' | translate }}</span>
      </div>
      <div
        (click)="onOrderChanged(listHeaderSortKeys.qualification)"
        [ngClass]="{
          sortable: !orderDirection || orderKey !== listHeaderSortKeys.qualification,
          'sortable-asc': orderDirection === directions.asc && orderKey === listHeaderSortKeys.qualification,
          'sortable-desc': orderDirection === directions.desc && orderKey === listHeaderSortKeys.qualification,
          pointer: endedAssignments?.length
        }"
        class="col-4"
      >
        <span baseTruncate>{{ 'qualifications.singular' | translate }}</span>
      </div>
    </div>
    <div
      *ngFor="let endedAssignment of endedAssignments"
      class="listview-item bg-lightest mb-5"
    >
      <div class="row">
        <div class="col-4">
          <span>{{ endedAssignment.startDate | baseFormatDate }} - {{ endedAssignment.endDate | baseFormatDate }}</span>
        </div>
        <div class="col-3">
          <span>{{ endedAssignment.customerDepartment.name }}</span>
        </div>
        <div class="col-4">
          <span class="qualification-text-color">{{ endedAssignment.mainQualification.name }}</span>
        </div>
      </div>
    </div>

    <base-empty-list-row
      *ngIf="!endedAssignments?.length"
      message="externalEmployees.masterData.recentAssignments.emptyList"
      [hideBackgroundImage]="true"
      [backgroundSecondary]="true"
    ></base-empty-list-row>
  </div>
</ng-container>

<ng-template #idCardViewerTemplate>
  <base-document-viewer
    [title]="'externalEmployees.masterData.employeeIdCard.title' | translate"
    [src]="activeDocumentSrc"
    [fileName]="idCardFileName"
    [fileType]="baseAvailableFileTypeEnum.pdf"
    [modalRef]="idCardModalRef"
    [hideBorder]="true"
    height="400px"
    (downloadImage)="downloadIDCard()"
  ></base-document-viewer>
</ng-template>
